<!--
Jodit 에디터
-->
<template>
    <div>
    </div>
</template>

<script>
    // Jodit 에디터
    import 'jodit/build/jodit.min.css'
    let {Jodit} = require('jodit');

    export default {
        components: {
        },
        props: {
            /**
             * 에디터 옵션
             */
            options: {
                type: Object,
                default: () => {return {};},
            },

            /**
             * 초기내용
             */
            initValue: {
                type: String,
                default: null,
            },
        },
        data: function () {
            return {
                /**
                 * jodit 에디터
                 */
                jodit: null,

                /**
                 * 에디터 옵션
                 */
                joditOptions: _.assignIn({
                    "uploader": {
                        "insertImageAsBase64URI": true
                    },

                    // 툴바
                    buttons: 'source,|,bold,strikethrough,underline,italic,|,superscript,subscript,|,ul,ol,|,outdent,indent,|,font,fontsize,brush,paragraph,|,image,file,video,table,link,|,align,undo,redo,\\n,cut,hr,eraser,copyformat,|,symbol,fullsize,selectall,print',

                    // 모바일모드를켜두면, 에디터 width 계산이 잘못되어서 툴바메뉴가 전부 다 안나옴.
                    disablePlugins: ['mobile'],

                    // 글꼴
                    style: {
                        'font-size': '14px',
                    }
                }, this.options),
            };
        },
        mounted () {
            //console.log(this.joditOptions);
            this.jodit = new Jodit(this.$el, this.joditOptions);

            // 초기내용 설정
            if (this.initValue) {
                this.setEditorValue(this.initValue);
            }
        },
        computed: {
        },
        methods: {
            /**
             * jodit editor 반환
             * @returns object
             */
            getJodit() {
                return this.jodit;
            },

            /**
             * 에디터 내용설정
             * @param value
             * @returns string
             */
            setEditorValue(value) {
                return this.jodit.setEditorValue(value);
            },

            /**
             * 에디터 내용반환
             * @returns string
             */
            getEditorValue() {
                return this.jodit.getEditorValue();
            },
        },

    }
</script>

<style lang="scss" scoped>
</style>